import { useContext } from 'react';
import languageContext from '@/context/language';
import { useCountry } from './use-country';

type PriceFormatter = {
  (value: number | string): string;
  roundVat: (value: number | string) => string;
};

export const usePriceFormat = (lang = '') => {
  const { isKR } = useCountry();
  if (!lang) {
    lang = useContext(languageContext).lang;
  }

  const formatPrice = (value, roundKR = false) => {
    if (!value) value = 0;
    let formatOption = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
    if (isKR) {
      formatOption = { maximumFractionDigits: 0, minimumFractionDigits: 0 };
      value = roundKR ? Math.round(value) : Math.trunc(value);
    }
    return new Intl.NumberFormat(lang, formatOption).format(value);
  };

  const getPriceFormat: PriceFormatter = (value) => formatPrice(value);
  getPriceFormat.roundVat = (value) => formatPrice(value, true);

  return getPriceFormat;
};
